<template lang="html">
  <div class="members">
    <el-table
      :data="members.list"
      style="width: 100%"
      v-if="members !== null"
      :loading="loading" border stripe>
      <el-table-column
        prop="user.name"
        :label="$t('name')" width="200">
      </el-table-column>
      <el-table-column
        prop="user.email"
        :label="$t('email')" width="200">
      </el-table-column>
      <el-table-column
        :label="$t('mobile')" width="180">
        <template slot-scope="scope">
          <div class="ltr">{{ scope.row.user.mobile }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('role')">
        <template slot-scope="scope">
          <span>{{ $t(scope.row.role.name) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('confirmation_status')"
        width="180">
        <template slot-scope="scope">
          <span>{{ $t(scope.row.user.confirmation_status) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('inboxes')"
        width="480">
        <template slot-scope="scope">
          <strong
            v-for="(inbox, index) in scope.row.inbox_access.inboxes"
            :key="inbox.id.numberStr">
            {{ inbox.name }}<template v-if="index < scope.row.inbox_access.inboxes.length - 1">،</template>
          </strong>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    user: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      members: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters([
      'domainsPath'
    ])
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    toggleLoading () {
      this.loading = !this.loading
    },
    setData (res) {
      this.members = res
    },
    getData () {
      const { domainsPath, user, $route } = this
      this.handleRequest({
        name: `${domainsPath}/users/${user}/teams/${$route.params.id}/members`,
        action: 'getAll',
        data: {
          query: {
            limit: 1000
          }
        }
      })
        .then(this.setData)
        .finally(this.toggleLoading)
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="css">
</style>
